import cookies from 'vue-cookies';
import router from '@/router/index.js';
import dotenv from 'dotenv';
import mobileTitle from './mobilePageTitle.json';

dotenv.config();

export const helpers = {
  getLang() {
    const lang = localStorage.getItem('language');
    if (lang) return lang;

    const naviLang = navigator.language || navigator.userLanguage || 'en';

    return naviLang.split('-')[0];
  },
  getLocalLang() {
    const lang = localStorage.getItem('language');
    return lang;
  },
  // getWindowLang() {
  //   const [windowLang] = window.navigator.language.split('-');
  //   return windowLang;
  // },
  loginHeaders() {
    const fcmToken = cookies.get('fcmToken');
    const headers = {
      headers: {
        fcmToken,
      },
    };
    return headers;
  },
  toStringByFormatting(source, delimiter = '-') {
    const year = source.getFullYear();
    const month = String(source.getMonth() + 1).padStart(2, '0');
    const day = String(source.getDate()).padStart(2, '0');
    return [year, month, day].join(delimiter);
  },
  readProperty() {
    const cookie = cookies.get('readProperty');

    if (cookie) {
      const cookieDate = new Date(cookie);
      const nowDate = new Date(helpers.toStringByFormatting(new Date()));
      const daysBerweenDates = () => Math.round(Math.abs(cookieDate - nowDate) / (1000 * 60 * 60 * 24)) > 0;

      return daysBerweenDates();
    }

    return true;
  },
  getWindowWidth: () => window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
  getCurrentYear: () => new Date().getFullYear(),
  setMobileHeader() {
    const routeName = router.app?._route.name;
    const rn = routeName?.includes('MyBuildings') && routeName?.includes('Mobile') ? 'MyBuildings' : routeName;

    return mobileTitle[rn];
  },
};
